<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base position-relative top-119">
    <div class="container pt-32 pb-5">
      <h1 class="text-white h1-size">Alta Relojoaria</h1>
    </div>
    <div class="container">
      <div class=" row d-flex justify-content-center">
        <ng-container *ngFor="let item of marcasAlta">
          <a class="card m-1 grayscale clock-expand clock-shadow-card pointer" href="{{link(item)}}">
            <img src="https://{{apiUrl}}/api/marcas/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top grayscale" alt="...">
          </a>
        </ng-container>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-12 mb-5" *ngIf="!showAll">
      <button type="button" class="btn btn-yellow-grad px-16" (click)="toogle()">Ver mais</button>
    </div>
    <div class="container pt-32 pb-5" *ngIf="showAll">
      <h1 class="text-white h1-size">Relojoaria</h1>
    </div>
    <div class="container" *ngIf="showAll">
      <div class=" row d-flex justify-content-center">
        <ng-container *ngFor="let item of marcasRel">
          <a class="card m-1 grayscale clock-expand clock-shadow-card pointer" href="{{link(item)}}">
            <img src="https://{{apiUrl}}/api/marcas/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top grayscale" alt="...">
          </a>
        </ng-container>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-12 mb-5" *ngIf="showAll">
      <button type="button" class="btn btn-yellow-grad px-16" (click)="toogle()">Ver menos</button>
    </div>
  </section>
</div>
